import { brand } from '@/styles/brand';
import { colors } from '@/styles/color';
import { fontSize, fontWeight } from '@/styles/font';

/** 컴포넌트 공통 톤앤매너 (타이포·표면·인터랙션) */
export type UiTypes = typeof ui;

export const ui = {
	letterSpacing: {
		tight: '-0.03em',
		body: '-0.02em',
		caption: '-0.01em',
		label: '0.08em',
	},
	lineHeight: {
		display: '1.15',
		heading: '1.3',
		body: '1.6',
		ui: '1.5',
	},
	surface: {
		page: '#ffffff',
		subtle: colors.gray,
		muted: colors.gray100,
		headerOverlay: brand.headerOverlay,
		headerSolid: '#ffffff',
		megaIntro: colors.gray,
		megaLinks: '#ffffff',
		megaGrid: colors.gray100,
		megaAccent: colors.gray100,
	},
	border: {
		default: colors.gray100,
		strong: colors.gray200,
	},
	text: {
		primary: colors.grayDarker,
		secondary: colors.grayMid,
		muted: colors.grayLight,
		inverse: '#ffffff',
		inverseSoft: colors.primary100,
		accent: colors.primary400,
	},
	interactive: {
		primary: colors.primary400,
		primaryHover: '#0e4280',
		primaryMuted: colors.primary50,
		focusRing: brand.focusRing,
		hoverWash: 'rgba(18, 83, 158, 0.08)',
	},
	nav: {
		mainFontSize: fontSize.sizeLg,
		mainFontWeight: fontWeight.weightSemi,
		authFontSize: fontSize.sizeMd,
		underlineHeight: '2px',
	},
	mega: {
		labelFontSize: fontSize.size2xs,
		labelFontWeight: fontWeight.weightBold,
		titleFontSize: fontSize.size3xl,
		titleFontWeight: fontWeight.weightBold,
		descFontSize: fontSize.sizeSm,
		descFontWeight: fontWeight.weightRegular,
		linkFontSize: fontSize.sizeMd,
		linkFontWeight: fontWeight.weightRegular,
		linkActiveFontWeight: fontWeight.weightSemi,
		viewMoreFontSize: fontSize.sizeXs,
		viewMoreFontWeight: fontWeight.weightMedium,
		brandFontSize: fontSize.size2xs,
		gridLine: 'rgba(18, 83, 158, 0.06)',
		brandOpacity: 'rgba(0, 21, 52, 0.28)',
	},
	chip: {
		fontSize: fontSize.size2xs,
		fontWeight: fontWeight.weightBold,
		radius: '1.6rem',
		border: `1px solid rgba(134, 142, 150, 0.28)`,
		shadow: '0 8px 20px rgba(18, 83, 158, 0.08)',
	},
	form: {
		controlHeight: '4.8rem',
		controlRadius: '1.2rem',
		controlPaddingX: '1.6rem',
		labelFontSize: fontSize.sizeSm,
		labelFontWeight: fontWeight.weightSemi,
	},
} as const;
